import {SearchResultType} from './search-result-type';

export interface SearchTypeLabel {
  label: string;
  icon: string;
  route: string;
}

export const SEARCH_TYPE_LABELS: Record<SearchResultType, SearchTypeLabel> = {
  VOCAB_CATEGORY: {label: 'Wortschatzthema', icon: 'topic', route: '/wortschatz'},
  VOCAB_ENTRY: {label: 'Wortschatz', icon: 'menu_book', route: '/wortschatz'},
  FUNCTIONAL_GRAMMAR_CATEGORY: {label: 'Funktionale Grammatik – Thema', icon: 'topic', route: '/grammatik'},
  FUNCTIONAL_GRAMMAR_ENTRY: {label: 'Funktionale Grammatik', icon: 'rule', route: '/grammatik'},
  SYSTEMIC_GRAMMAR_CATEGORY: {label: 'Systematische Grammatik – Thema', icon: 'topic', route: '/grammatik'},
  SYSTEMIC_GRAMMAR_ENTRY: {label: 'Systematische Grammatik', icon: 'rule', route: '/grammatik'},
  DETAILED_CDS_CATEGORY: {label: 'Kannbeschreibungen (detailliert) – Thema', icon: 'topic', route: '/kannbeschreibungen'},
  DETAILED_CDS_ENTRY: {label: 'Kannbeschreibungen (detailliert)', icon: 'check_circle', route: '/kannbeschreibungen'},
  GLOBAL_CDS_CATEGORY: {label: 'Kannbeschreibungen (global) – Thema', icon: 'topic', route: '/kannbeschreibungen'},
  GLOBAL_CDS_ENTRY: {label: 'Kannbeschreibungen (global)', icon: 'check_circle', route: '/kannbeschreibungen'},
  TEXT_TYPE: {label: 'Textsorte', icon: 'description', route: '/textsorten'},
  TEXT_PATTERN: {label: 'Textmuster', icon: 'article', route: '/textmuster'},
  VERBAL_ACTION_CATEGORY: {label: 'Sprachhandlungen – Thema', icon: 'topic', route: '/sprachhandlungen'},
  VERBAL_ACTION_ENTRY: {label: 'Sprachhandlung', icon: 'record_voice_over', route: '/sprachhandlungen'},
};
